import { useCallback } from 'react'
import { validateEmail } from 'lib/util'
import { SchoolLookUpSiteData } from 'types'
import { Steps } from './useAssignFormState'

interface UseStepValidationProps {
  activeTab: number
  schoolData: SchoolLookUpSiteData
  email: string
  confirmEmail: string
  isConfirmed: boolean
  setIsStepValid: (isValid: boolean) => void
}

export const useStepValidation = ({
  activeTab,
  schoolData,
  email,
  confirmEmail,
  isConfirmed,
  setIsStepValid,
}: UseStepValidationProps) => {
  const validateSchool = useCallback(() => {
    const isValid =
      schoolData.country &&
      schoolData.city &&
      (schoolData.netsuiteCustomerId !== null || schoolData.organizationName)

    setIsStepValid(!!isValid)
    return !!isValid
  }, [schoolData, setIsStepValid])

  const validateLicenseAdmin = useCallback(() => {
    const isValid =
      email && confirmEmail && email === confirmEmail && validateEmail(email)
    setIsStepValid(isValid)
    return isValid
  }, [email, confirmEmail, setIsStepValid])

  const validateConfirm = useCallback(() => {
    const isValid = isConfirmed
    setIsStepValid(isValid)
    return isValid
  }, [isConfirmed, setIsStepValid])

  const validateCurrentStep = useCallback(() => {
    switch (activeTab) {
      case Steps.School:
        return validateSchool()
      case Steps.LicenseAdmin:
        return validateLicenseAdmin()
      case Steps.Confirm:
        return validateConfirm()
      default:
        return false
    }
  }, [activeTab, validateSchool, validateLicenseAdmin, validateConfirm])

  return {
    validateCurrentStep,
    validateSchool,
    validateLicenseAdmin,
    validateConfirm,
  }
}
